@if (banner && !wasClosed) {
  <div class="bottom-fixed-banner" [@bannerFixed]>
    <div class="bottom-fixed-banner-child">
      <a (click)="close()" class="bottom-fixed-banner-close app-cursor">{{
        'web.close' | translate | transinit
      }}</a>
      @if (banner.url) {
        <a
          target="_blank"
          href="{{ banner.url }}{{ utm(banner.url) }}"
          (click)="click()"
          [id]="bannerPositionId + ' | ' + banner.url"
          class="app-banner-main"
          >
          <img
            src="{{ banner.path }}"
            class="banner"
            fetchpriority="high"
            alt="{{ banner.altText }}"
            class="bottom-fixed-banner__image"
                    srcset="{{ banner.small_image }} 600w,
                    {{ banner.medium_image }} 1024w,
                    {{ banner.large_image }} 1600w"
            />
        </a>
      } @else {
        @if (!banner.url) {
          <img
            src="{{ banner.path }}"
            class="banner"
            fetchpriority="high"
            alt="{{ banner.altText }}"
                    srcset="{{ banner.small_image }} 600w,
                        {{ banner.medium_image }} 1024w,
                        {{ banner.large_image }} 1600w"
            class="bottom-fixed-banner__image"
            />
        }
      }
    </div>
  </div>
}
